import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import type { PublicationEditionModel } from '@models/types'

interface SelectedEditionProps {
  onClick: VoidFunction,
  publicationEdition: PublicationEditionModel,
}

const SelectedEdition = (props: SelectedEditionProps) => {
  const { onClick, publicationEdition } = props

  return (
    <Button
      border="1px solid"
      buttonStyle="secondaryUtility"
      icon={<FontAwesomeIcon icon={faCalendar} />}
      onClick={onClick}
      size="medium"
      width="auto"
    >
      {publicationEdition.title}
    </Button>
  )
}

export default SelectedEdition
